/* @jsx node */
import { node, dom } from 'jsx-pragmatic';
import { env } from '../../app/utils';
import { config } from './config';

export const options = {
  ...config,
  defaultEnv: env.environment,
  dimensions: { width: '100%', height: '100%' },
  defaultLogLevel: 'error',
  prerenderTemplate: function({ doc }) {
    const template = (
      <html>
        <body style="display: none !important;"></body>
      </html>
    );

    return template.render(dom({ doc }));
  },
};
